// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__2-tAO","title":"AfterBackImages_title__1hXeW","images":"AfterBackImages_images__3E-80"};